
import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';
import { LndSuccessMsgComponent } from '../lnd-success-msg/lnd-success-msg.component';
import { AddFacultyPopupComponent } from '../add-faculty-popup/add-faculty-popup.component';


@Component({
  selector: 'app-add-program',
  templateUrl: './add-program.component.html',
  styleUrls: ['./add-program.component.scss'],
})
export class AddProgramComponent  implements OnInit {
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  pmsYears: any = [];
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
  loggedInCompanyFiscalyear: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  addProgramForm: FormGroup;
  buttonColorName: any;
  trainingTypes = ['Online', 'Offline'];
  functionalOptions = ['Functional', 'Behavioral'];
  departments = ['Sales', 'Accounting', 'IT','Marketing'];
  bands = ['A', 'B', 'C'];
  grades = ['Leadership', 'Executive', 'Manager','Junior'];
  addFacultyForm: any;
  selectedTrainingType: string = '';

  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService, public dialogRef: MatDialogRef<AddProgramComponent>
  )  {
  
    this.addProgramForm = this.fb.group({
      
      trainingType: ['', Validators.required],
      programTitle: ['', Validators.required],
      programCode: ['', Validators.required],
      lmsLink: ['',Validators.required],
      starTime: ['',Validators.required],
      startDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      endDate: ['', Validators.required],
      functionalBehavioral: ['', Validators.required],
      programDays: ['', Validators.required],
      budgetCost: ['', Validators.required],
      actualCost: ['', Validators.required],
      facultyName: ['', Validators.required],
      objective: ['', Validators.required],
      department: ['', Validators.required],
      band: ['', Validators.required],
      grade: ['', Validators.required],
      location: ['',Validators.required]
    });
  }
 
  ngOnInit(): void {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
      this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
      this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
      this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
      this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
      if (this.loggedInCompanyFiscalyear) {
        this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
      }
      this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
      this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
      this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
      if (this.loggedInUserRole) {
        this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
      }
      this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
      this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
      if (this.loggedInUserRoles.length == 1) {
        for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
          if (this.loggedInUserRoles[i].displayName == "Employee") {
            this.loggedInUserRoleIsEmployee = true
          }
        }
      }
      this. getpmsyearlist();
    }
  



  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear)
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;   
      this.setSelectedYear(yearValue);
    });
  }
  

  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
          this.selectedYearForCompetency = selectedYearObj?.year;
         
          let test = selectedYearObj?.year.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
           this. getDepartmentForDropdown();
          this.getBandForDropdown();
          this.getGradeForDropdown();
          this.timeSlots = this.generateTimeSlots();
          [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
    }
  }



    getYearSetupForReimbursement(year: any) {
      this.selectedYearForCompetency = year;
      this.selectedYear = year;
    }
  

    onClickAddNewFacultyPopup(){
      const dialogConfig = new MatDialogConfig();
            dialogConfig.height = '70%';
            dialogConfig.width = '70%';
            dialogConfig.data = {};
            dialogConfig.panelClass = 'custom-dialog-container';
            const dialogRef = this.dialog.open(AddFacultyPopupComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(result => {
              
            });
    }


  closeDialog() {
     this.dialogRef.close();
  }


  openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
    return this.dialog.open(ConfirmationPopupComponent, {
      disableClose: false,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: buttonText,
        btn2BgColor: buttonColor,
        showSuccessIcon: showSuccessIcon,
        showSuccessMessage: showSuccessMessage,
        showCloseIcon: showCloseIcon
      }
    });
  }
  



  // =================================================  Add Training Program Form ===========================================================================


  //  ===================================  Training Type change =========================================

  onTrainingTypeChange(value:string){
   this.selectedTrainingType = value;

  }


  // ================================ Convert Time to 24 hours  =========================================
  convertTo24HourWithSeconds(time: string | undefined): string {
    if (!time || typeof time !== 'string') {
      console.error('Invalid time input:', time);
      return '00:00:00'; // or handle accordingly
    }
  
    const [hourMin, modifier] = time.split(' ');
    if (!hourMin || !modifier) {
      console.error('Time format error:', time);
      return '00:00:00';
    }
  
    let [hours, minutes] = hourMin.split(':').map(Number);
  
    if (modifier === 'PM' && hours < 12) {
      hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }
  
    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');
    return `${paddedHours}:${paddedMinutes}:00`;
  }
  


  // ===========================  Time Slot Dropdown Function ================================================

  timeSlots: string[] = [];

  generateTimeSlots(): string[] {
    const slots = [];
    const start = 0; // 12:00 AM
    const end = 24 * 60; // 12:00 AM next day
    const step = 30; // 30-minute intervals
  
    for (let mins = start; mins < end; mins += step) {
      const hours = Math.floor(mins / 60);
      const minutes = mins % 60;
      const period = hours >= 12 ? 'PM' : 'AM';
      const displayHours = hours % 12 === 0 ? 12 : hours % 12;
      const time = `${this.pad(displayHours)}:${this.pad(minutes)} ${period}`;
      slots.push(time);
    }
    return slots;
  }
  
  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  



  // ====================================  Submit Form ========================================================
    
  facultyId:any
  isSubmitting = false;
  // addSubmitForm: boolean = false;
    submitTrainingProgram1() {
    //   // if (this.addProgramForm.invalid) {
    //   //   return;
    //   // }
    
    //   const programPayload = this.addProgramForm.value;
    
    //   // If this is an update, include the ID or unique key
    //   if (this.data?.programData?.id) {
    //     programPayload.id = this.data.programData.id;
    //   }
    
    // // if (this.addProgramForm.invalid) {
    // //   this.addSubmitForm = true;
    // //   this.addProgramForm.markAllAsTouched();
    // //   return;
    // // }

    // this.isSubmitting = true;
    // // const isEdit = !!this.data?.programData;
    //   const payload = {
    //     "trainingType": this.addProgramForm.value.trainingType,
    //     "programmeTitle": this.addProgramForm.value.programTitle,
    //     "programmeCode": this.addProgramForm.value.programCode,
    //     "lmsLink": this.addProgramForm.value.lmsLink,
    //     "startDate": this.addProgramForm.value.startDate,
    //     "endDate": this.addProgramForm.value.endDate,
    //     starTime: this.convertTo24HourWithSeconds(this.addProgramForm.value.starTime),
    //     endTime: this.convertTo24HourWithSeconds(this.addProgramForm.value.endTime),
    //     "functionalOrBehavioral": this.addProgramForm.value.functionalBehavioral,
    //     "objective": this.addProgramForm.value.objective,
    //     department: this.addProgramForm.value.department?.[0] || '',
    //      band: this.addProgramForm.value.band?.[0] || '',
    //     grade: this.addProgramForm.value.grade?.[0] || '',
    //     "location": this.addProgramForm.value.location,
    //     "numberOfProgramDays": this.addProgramForm.value.programDays,
    //     "budgetCost": this.addProgramForm.value.budgetCost,
    //     "actualCost": this.addProgramForm.value.actualCost,
    //     "facultyId":this.facultyId,
    //     "nominatedHodOrManager": null,
    //     companyId: this.loggedInUserCompanyID,
    //     year: this.selectedYear || this.selectedYearForCompetency,
    //     fiscalYear:this.loggedInCompanyFiscalyear
        
    //   };
    
    //   this.httpService.callPostService(`${this.config.saveTrainingProgram}`, payload).subscribe({
    //     next: async (result: any) => {
    //       console.log('Saved successfully:', result);
    //       // const msg = isEdit ? 'Training program updated successfully' : 'Training program created successfully';
    //       // this.openDialog(msg, 'OK', this.buttonColorName, false, false, false);
    //       this.dialogRef.close('updated'); // pass back to trigger refresh
    //       this.isSubmitting = false;
    //     },
    //     error: async (err: any) => {
    //       this.openDialog(err.error.message || 'Something went wrong', 'OK', 'red', false, false, false);
    //       this.isSubmitting = false;
    //     }
    //   });
    }
    


  programId:any;
  submitTrainingProgram() {
    const faculties = JSON.parse(sessionStorage.getItem('addedFaculties') || '[]');
  
    const payload = {
      id: this.programId || null,
      trainingType: this.addProgramForm.value.trainingType,
      programmeTitle: this.addProgramForm.value.programTitle,
      programmeCode: this.addProgramForm.value.programCode,
      lmsLink: this.addProgramForm.value.lmsLink,
      startDate: this.addProgramForm.value.startDate,
      endDate: this.addProgramForm.value.endDate,
      startTime: this.convertTo24HourWithSeconds(this.addProgramForm.value.starTime),
      endTime: this.convertTo24HourWithSeconds(this.addProgramForm.value.endTime),
      functionalOrBehavioral: this.addProgramForm.value.functionalBehavioral,
      objective: this.addProgramForm.value.objective,
      department: this.addProgramForm.value.department?.[0] || '',
      band: this.addProgramForm.value.band?.[0] || '',
      grade: this.addProgramForm.value.grade?.[0] || '',
      location: this.addProgramForm.value.location,
      numberOfProgramDays: this.addProgramForm.value.programDays,
      budgetCost: this.addProgramForm.value.budgetCost,
      actualCost: this.addProgramForm.value.actualCost,
      nominatedHodOrManager: null,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear || this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
      faculty: faculties  
    };
  
    this.httpService.callPostService(this.config.saveTrainingProgram, payload).subscribe({
      next: () => {
        this.toastr.success('Training Program saved successfully!');
        sessionStorage.removeItem('addedFaculties'); 
      },
      error: (err) => {
        this.toastr.error(err.error.message || 'Error saving program');
      }
    });
  }
  


  // patchFormData(program: any): void {
  //   console.log(program);
    
  //   this.addProgramForm.patchValue({
  //     trainingType: program.trainingType,
  //     programmeTitle: program.programmeTitle,
  //     programmeCode: program.programmeCode,
  //     lmsLink: program.lmsLink,
  //     startDate: program.startDate,
  //     endDate: program.endDate,
  //     starTime: program.starTime,
  //     endTime: program.endTime,
  //     functionalOrBehavioral: program.functionalOrBehavioral,
  //     department: Array.isArray(program.department) ? program.department : [program.department],
  //     band: Array.isArray(program.band) ? program.band : [program.band],
  //     grade: Array.isArray(program.grade) ? program.grade : [program.grade],
  //     location: program.location,
  //     numberOfProgramDays: program.numberOfProgramDays,
  //     budgetCost: program.budgetCost,
  //     actualCost: program.actualCost,
  //     faculty: {
  //       facultyName: program.faculty?.facultyName || ''
  //     },
  //     objective: program.objective
  //   });
  // }
  


   // ======================================= add Training Program Dropdowns ======================================
  
  
  
  // =================== Dropdown for Department ================
  
  selectedDepartment: any =[];
  getDepartmentsList: any[]=[];
 

  dropdownSettings = {
    singleSelection: false,  
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  onDepartmentSelect(){

  }

  onDepartmentDeSelect(){

  }

  onDepartmentAllSelect(){

  }

  onDepartmentAllDeSelect(){

  }


  getDepartmentForDropdown() {
    const apiUrl = `${this.config.getAllDept + this.loggedInUserCompanyID}`;
    
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        console.log("getdepartment====", response);
        if (response?.data) {
          this.getDepartmentsList = response.data;
        }
      },
      error: (error) => {
        console.error("Error fetching departments", error);
      }
    });
  }



  // ================================ Dropdwon for band =================================================

  selectedBand: any =[];
  getBandList:any[]=[]

  dropdownbandSettings = {
    singleSelection: false,  
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };


  onSelectBand(){

  }

  onDeSelectBand(){

  }

  onSelectAllBand(){

  }
  onDeSelectAllBand(){

  }

  getBandForDropdown() {
    const apiUrl = `${this.config.getAllBand + this.loggedInUserCompanyID}`;
    
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        console.log("band====", response);
        if (response?.data) {
          this.getBandList = response.data;
        }
      },
      error: (error) => {
        console.error("Error fetching band", error);
      }
    });
  }

 

// ================================================ Dropdown For Grade ==================================================

selectedGrade: any =[];
getGradeList:any[]=[]

dropdownGradeSettings = {
  singleSelection: false,  
  idField: 'id',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 1,
  allowSearchFilter: true
};


  


onGradeSelect(){

}

onGradeDeselect(){

}

onGradeSelectAll(){

}
onGradeDeselectAll(){

}
  
  getGradeForDropdown() {
    const apiUrl = `${this.config.getAllGrade + this.loggedInUserCompanyID}`;
    
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        console.log("band====", response);
        if (response?.data) {
          this.getGradeList = response.data;
        }
      },
      error: (error) => {
        console.error("Error fetching Grade", error);
      }
    });
  }

 



}